/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Portals_Events_FailInputs */

const cs_portals_events_fail = /** @type {(inputs: Portals_Events_FailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Selhalo`)
};

const en_portals_events_fail = /** @type {(inputs: Portals_Events_FailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Failed`)
};

/**
* | output |
* | --- |
* | "Failed" |
*
* @param {Portals_Events_FailInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const portals_events_fail = /** @type {((inputs?: Portals_Events_FailInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Portals_Events_FailInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_portals_events_fail(inputs)
	return cs_portals_events_fail(inputs)
});